import { selectGameInfoError } from 'modules/overlay-v2/store/game-info/selectors';
import { selectIsMatchAvailable, selectIsMatchDataReady } from 'modules/overlay-v2/store/overlay/selectors';
import useInitOverlayV2 from 'modules/overlay-v2/ui/hooks/initializers/use-init-overlay-v2';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import OverlayMessage from 'shared/components/overlay-message';
import { useFetchAvailableFeature } from 'shared/hooks/fetchering/use-fetch-available-feature';
import { useAppSelector } from 'store/hooks';
import supabase from 'modules/core/supabase/supabase';

import { CanvasEventBoards } from '../components/canvas/canvas-event-boards';
import { CanvasStaticBoards } from '../components/canvas/canvas-static-boards';
import Joystick from '../components/joystick/joystick';
import OverlayConnectionIndicator from '../components/overlay-connection-indicator/overlay-connection-indicator';

function OverlayV2() {
  useInitOverlayV2();

  const isMatchAvailable = useAppSelector(selectIsMatchAvailable);
  const isMatchDataReady = useAppSelector(selectIsMatchDataReady);

  useEffect(() => {
    window.onerror = function (msg, url, line, col, error) {
      supabase.overlayLogs.createError({
        comment: 'overlay - общий',
        message: error?.stack ?? msg.toString(),
      });
    };
  }, []);

  const { organizerId } = useParams();
  const organizerIdNumber = useMemo(() => (organizerId ? Number(organizerId) : undefined), [organizerId]);
  const gameInfoError = useAppSelector(selectGameInfoError);

  const {
    data: feature,
    isLoading: isFeatureLoading,
    error: featureError,
  } = useFetchAvailableFeature({
    userTournamentId: organizerIdNumber,
  });

  useEffect(() => {
    const rootDiv = document.getElementById('root');
    const body = document.getElementsByTagName('body')[0];
    rootDiv?.setAttribute('style', 'background: unset');
    body?.setAttribute('style', 'background: unset; overflow: hidden');
  }, []);

  if (isMatchAvailable === undefined)
    return <OverlayMessage title={'Поиск запущенных матчей'} subtitle={'При плохом соединении загрузка может занимать несколько минут'} />;

  if (!isMatchAvailable) return <OverlayMessage title={'Ожидание начала матча'} />;

  if (gameInfoError) return <OverlayMessage variant={'error'} title={`Ошибка при получении информации о матче: ${gameInfoError}`} />;

  if (!isMatchDataReady)
    return <OverlayMessage title={'Загрузка, подождите'} subtitle={'При плохом соединении загрузка может занимать несколько минут'} />;

  if (featureError)
    return <OverlayMessage variant={'error'} title={`Ошибка при получении подписки: ${(featureError as Error)?.message}`} />;

  if (isFeatureLoading)
    return <OverlayMessage title={'Загрузка, подождите'} subtitle={'При плохом соединении загрузка может занимать несколько минут'} />;

  if (!feature?.OBS_INTEGRATION) {
    return <OverlayMessage variant={'error'} title={'Подписка не активирована'} />;
  }

  return (
    <div key={'overlay'} className={'flex justify-end'} style={{ width: '100%', height: '100vh' }}>
      <OverlayConnectionIndicator />
      <div
        className={'flex justify-end'}
        style={{
          background: 'unset',
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
      >
        <CanvasStaticBoards />
        <CanvasEventBoards />
      </div>
      {feature?.OBS_INTEGRATION && <Joystick key={'FullSizeControlPanel-old'} />}
    </div>
  );
}

export default OverlayV2;
